import { cva } from 'cva';
export const scrollAreaRootClassNames = [
    '@relative',
    '@overflow-hidden'
];
export const scrollAreaViewportClassNames = [
    '@h-full',
    '@w-full',
    '@rounded-[inherit]'
];
export const scrollAreaScrollbarVariants = cva({
    base: [
        '@flex',
        '@touch-none',
        '@select-none',
        '@transition-colors'
    ],
    variants: {
        orientation: {
            vertical: [
                '@h-full',
                '@w-[11px]',
                '@border-l',
                '@border-l-grey-2_3',
                '@p-0.5',
                '@bg-grey-2-a'
            ],
            horizontal: [
                '@h-[11px]',
                '@flex-col',
                '@border-t',
                '@border-t-grey-2_3',
                '@p-0.5',
                '@bg-grey-2-a'
            ]
        }
    },
    defaultVariants: { orientation: 'vertical' },
});
export const scrollAreaThumbClassNames = [
    '@relative',
    '@flex-1',
    '@rounded-full',
    '@bg-grey-4',
    'hover:@bg-grey-5'
];
